import { IStackProps } from "@fluentui/react";
import React, { FunctionComponent } from "react";

import { Stack } from "../layouts/stack/Stack";

export type FormFieldsProps = Pick<IStackProps, "children" | "styles">;

export const FormFields: FunctionComponent<FormFieldsProps> = (props: FormFieldsProps) => {
    const { children, styles } = props;

    return (
        <Stack tokens={{ childrenGap: 10 }} styles={styles}>
            {children}
        </Stack>
    );
};
